export const HttpConst = {
  headers: {
    CountryCode: 'Country-Code',
    UserRole: 'User-Role',
    ContentType: 'Content-type',
  },
};
